import { GoodListContainer, ListProducts } from "./GoodList.styled";
import { Header } from "./Header";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { motion } from "framer-motion";
import { PricingActualPlans } from "../../../interfaces";
import { GoodItem } from "../../PricingActualPage/Goods/GoodItem";
import { ShopGoodCart } from "../../../components/common";
import { DividerContainer } from "../Divider/Divider.styled";
import { PromoCodeApplied } from "../PromoCodeApplied";
import { EmptyGoods } from "../EmptyGoods";

interface GoodListProps {}

const listVariants = {
	hidden: { opacity: 0, y: 20 },
	visible: (i: number) => ({
		opacity: 1,
		y: 0,
		transition: {
			delay: i * 0.1,
			duration: 0.4,
			type: "spring",
		},
	}),
	exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
};

export const GoodList = observer(({}: GoodListProps) => {
	const { pricingActualStore, shopGoodsStore } = useStores();

	console.log("shopGoodsStore", shopGoodsStore.list.length);

	return (
		<GoodListContainer>
			<Header />

			<DividerContainer />

			<PromoCodeApplied />

			{shopGoodsStore.list.length > 0 ? (
				<ListProducts>
					{shopGoodsStore.list.map((good, index) => {
						return (
							<motion.div
								key={`${good.id}`}
								custom={`${index}`}
								initial="hidden"
								animate="visible"
								exit="exit"
								variants={listVariants}
								layout // позволяет плавно адаптироваться к перестановкам
								style={{ display: "flex" }}
							>
								{pricingActualStore.plans === PricingActualPlans.SUBSCRIPTION_PLANS && (
									<GoodItem shopGoodStore={good} {...good} />
								)}

								{pricingActualStore.plans !== PricingActualPlans.SUBSCRIPTION_PLANS && (
									<ShopGoodCart shopGoodStore={good} />
								)}
							</motion.div>
						);
					})}
				</ListProducts>
			) : (
				<EmptyGoods />
			)}
		</GoodListContainer>
	);
});
